module.exports = __webpack_public_path__ + "img/thumbs_up.6ff95c61.svg";